// eslint-disable-next-line
import Legacy from './Legacy/Legacy'
import Cadastro from './Cadastro/Cadastro'
import Contrato from './Contrato/Contrato'
import RemuneracaoMedica from './RemuneracaoMedica/RemuneracaoMedica'
import IntegradorFinxApi from './IntegradorFinx/Services/IntegradorFinxApi'
import FeedbackAPI from './Feedback/Feedback'
// eslint-disable-next-line
import Agendamento from './Agendamento/Agendamento'

export default {
  Legacy,
  Cadastro,
  Contrato,
  RemuneracaoMedica,
  Agendamento,
  IntegradorFinxApi,
  FeedbackAPI,
}
